import {
  LISTING_BOARD_COLUMN_CAP,
  LISTING_BOARD_COLUMN_ORDER,
} from './RentalPortalListingsBoard.constants'

export function getListingsByStatus(items) {
  return Object.fromEntries(
    LISTING_BOARD_COLUMN_ORDER.map(status => [
      status,
      items.filter(item => item.status === status),
    ])
  )
}

export function getListingsBoardColumnTotal({ items, statistic, status }) {
  return statistic[status] ?? items.length
}

export function getListingsBoardColumnItems({ items, total }) {
  const visibleItems = items.slice(0, LISTING_BOARD_COLUMN_CAP)

  return { hiddenCount: total - visibleItems.length, visibleItems }
}

export function getIsListingsBoardEmpty({ isLoading, items }) {
  return !isLoading && items.length === 0
}
